document.addEventListener("DOMContentLoaded",function() {
	const ledging = document.getElementsByClassName("ledging");
	if(ledging.length) {
		const ledgeItems = document.getElementsByClassName("ledge");

		if(ledgeItems.length) {
			// Navigation sidebar
			for (let i = 0; i < ledgeItems.length; i++) {
				ledgeItems[i].addEventListener("click", function () {
					removeSelected(ledgeItems);
					let clickedURL = this.getAttribute("href");
					let pageLink = document.getElementById(clickedURL);
					this.classList.add("selected");
					pageLink.scrollIntoView({behavior: "smooth"});
				});
			}

			// On scroll, detect visible
			const ledgeTexts = document.getElementsByClassName("ledge-texts");

			document.addEventListener("scroll", () => {
				removeSelected(ledgeItems);
				for (let i = 0; i < ledgeTexts.length; i++) {
					let ledgeText = ledgeTexts[i].id;
					let ledgeTextTop = ledgeTexts[i].getBoundingClientRect().top - 138;
					let ledgeTextBottom = ledgeTexts[i].getBoundingClientRect().bottom - 138;

					if(ledgeTextTop <= 0 && ledgeTextBottom >= 0) {
						let selectedLedge = document.querySelectorAll("a[href='"+ledgeText+"']");
						selectedLedge[0].classList.add("selected");
					}
				}
			});
		}


		function removeSelected(element) {
			for (var i = 0; i < element.length; i++) {
				element[i].classList.remove('selected');
			}
		}
	}
});